import styled from 'styled-components';

import { cssBreakpoints, gutterWidth, maxWidth } from 'theme';

export const PageContent = styled.div<{ $centered?: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  ${(props) =>
    props.$centered &&
    `
    width: 100%;
    max-width: ${maxWidth[2]}px;
    padding: 0 ${gutterWidth / 2}px;
    margin: 0 auto;
    @media all and (min-width: ${cssBreakpoints.mdUp}) {
      padding: 0 ${gutterWidth}px;
    }
  `}
`;
